module.exports = __webpack_public_path__ + "static/media/avatar1.198578e3.png";